import React, { useState, Component } from 'react';
import TextBox from '../Atoms/TextBox';
import { client } from '../../client';
import { Link } from 'react-router-dom'


class MediaHero extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      data : [],
      isHovered: false
      // url: ''
    }

  // This binding is necessary to make `this` work in the callback
  this.handleHover = this.handleHover.bind(this);

  }

  handleHover = () => this.setState({ isHovered: !this.state.isHovered });


  //this is where we receive API calls inside components
  componentDidMount() {
    client.getEntries()
      .then((response) => {
        // console.log(response.items[0].fields.thumbnail.fields.file.url)
        // console.log(response.items)
        
        this.setState({
          data: response.items
          
          // title : response.items[0].fields.title,
          // url : response.items[0].fields.thumbnail.fields.file.url
        })
    })
    .catch(console.error)
  }


  
  // {this.state.articles[0].fields.title}
  render() {
    const { content, cx } = this.props;
    const { data } = this.state;

    //
    // console.log(this.state.data)

    return ( <div className="media-hero-container w-90 flex large-maxh-25 phone-w-75">
      {/* Image */}
          {data.map((featuredWork, index) => (
            //Checking if work is set as featured
            featuredWork.fields.featured ? 
            // <Link to={`/post/${cardData.sys.id}`} className={`card flex wrap height-fit hover-animation phone-center ${cx} ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}></Link>
            
            //todo: perfect circle
            <Link to={`/post/${featuredWork.sys.id}`} className={`w-100 flex items-bottom hidden hover-animation-fast phone-wrap pos-relative phone-visible phone-flex-column ${this.state.isHovered ? "" : "br-medium"}`} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
              
              <div className="w-100 flex pos-relative tablet-full-height phone-cirle phone-h-auto">
                <img className="w-100 ba fit-cover phone-inner-circle full-height phone-br-100 phone-fit-cover phone-minus-margin " src={`${featuredWork.fields.thumbnail.fields.file.url}?w=1200&h=800&fm=jpg&fl=progressive`} alt="Featured Work"/> 
                <div className="pos-absolute small-ball ba"></div>
              </div>

              {/* <div className="w-100 phone-cirle pos-relative">
                <img className="w-100 ba fit-cover phone-inner-circle phone-br-100 phone-fit-cover phone-minus-margin " src={`${featuredWork.fields.thumbnail.fields.file.url}?w=1200&h=800&fm=jpg&fl=progressive`} alt="Featured Work"/>  */}
              {/* </div> */}

              {/* <TextBox width="third" firstLevel="h2" secondLevel="i" thirdLevel="p" cx={`pa-m pos-absolute`} br="small" border="ba" bg={true} bgColor={`${this.state.isHovered ? "bg-hover" : "bg"}`} firstContent={`${featuredWork.fields.title} (${featuredWork.fields.year}) `} secondContent={featuredWork.fields.titleEnglish} thirdContent={featuredWork.fields.exhibitionPlace}/> */}
              <TextBox width="third" firstLevel="h2" secondLevel="i" thirdLevel="p" cx={`pa-m pos-absolute phone-relative phone-w-100 phone-pa-0 phone-bt`} br="small phone-br-0" border="ba phone-b0" bgColor={`${this.state.isHovered ? "bg-hover" : "bg"}`} firstContent={`${featuredWork.fields.title} (${featuredWork.fields.year}) `} secondContent={featuredWork.fields.titleEnglish} thirdContent={featuredWork.fields.exhibitionPlace}/>
              
            </Link>
            
            
            
            : 
            ''
              
            ) 
          )
          }


      
      {/* <TextBox width="third" firstLevel="p" secondLevel="i" thirdLevel="p" cx="pa-m pos-absolute" br="small" border="ba" bg={true} firstContent={}/> */}
    </div>
    
    );
  }
}


export default MediaHero;

